import type { ItemPrice } from './Item';
import type { User } from './User';

export enum CartState {
  WAITING = 'Waiting',
  PAID = 'Paid',
  APPROVED = 'Approved',
}

export enum CartPeriod {
  MONTHLY = 1,
  QUARTERLY = 3,
  HALF_YEARLY = 6,
  YEARLY = 12,
}

export interface CartItem {
  id: number;
  cart_id: number;
  price_id: number;
  quantity: number;
  item_price: ItemPrice;
}

export interface CartPriceBreakdown {
  subtotal: number; // in cents
  promo_discount: number; // in cents
  promo_discount_percent: number;
  period_discount: number; // in cents
  period_discount_percent: number;
  total: number; // in cents
}

export interface Cart {
  id: number;
  user_id: number;
  name: string;
  state: CartState | null;
  created_by_doctor: number | null;
  period: CartPeriod;
  medications: string | null;
  started: string | null; // date format
  promo: number;
  created_at?: string;
  updated_at?: string;
  items?: Array<CartItem>;
  price_breakdown?: CartPriceBreakdown;
  user?: User;
}
